import { render, staticRenderFns } from "./MpGuidance.vue?vue&type=template&id=765ff104&"
import script from "./MpGuidance.vue?vue&type=script&lang=js&"
export * from "./MpGuidance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports